module.exports = __webpack_public_path__ + "static/media/alliance.3550541b.png";